export default "__VITE_ASSET__BJYCD3LA__"